// import React, { useEffect, useState } from "react";
// import { Box, Grid, Paper, Typography, useTheme } from "@mui/material";
// import { ResponsivePie } from "@nivo/pie";
// import { ResponsiveBar } from "@nivo/bar";
// import { ResponsiveLine } from "@nivo/line";
// import useWarehouseDashboard from "../../../hooks/warehouse/useWarehouseDashboard";
// import { useSSR } from "react-i18next";

// const WarehouseDashboard = () => {
//   const theme = useTheme();

//   const { totalStock, inwardShipment, outwardShipment, spaceUtilization, loading, error,kpiData,inventoryCategory,inwardAndOutwardShipment, fetchDashBoardTopDetails, } = useWarehouseDashboard();
//   const [isDataLoad, setIsDataLoad] = useState(false);
//   // load dashboard data 
//   useEffect(() => {
//     if (!isDataLoad) {
//       fetchDashBoardTopDetails();
//       setIsDataLoad(true);
//     }
//   })



//   // ---- Component Render ----
//   return (
//     <Box sx={{ p: 2 }}>
//       <Typography variant="h5" gutterBottom fontWeight="bold">
//         🏭 Warehouse Dashboard
//       </Typography>

//       {/* KPI Summary */}
//       <Grid container spacing={2} sx={{ mb: 2 }}>
//         {kpiData.map((kpi, index) => (
//           <Grid item xs={12} sm={6} md={2.4} key={index}>
//             <Paper
//               elevation={3}
//               sx={{
//                 p: 2,
//                 borderRadius: 3,
//                 textAlign: "center",
//                 bgcolor: theme.palette.mode === "dark" ? "#1e1e1e" : "#fafafa",
//               }}
//             >
//               <Typography variant="subtitle2" color="text.secondary">
//                 {kpi.title}
//               </Typography>
//               <Typography variant="h6" fontWeight="bold">
//                 {kpi.value}
//               </Typography>
//             </Paper>
//           </Grid>
//         ))}
//       </Grid>

//       {/* Charts Section */}
//       <Grid container spacing={2}>
//         {/* Bar Chart - Stock by Warehouse */}
//         <Grid item xs={12} md={6}>
//           <Paper elevation={3} sx={{ height: 300, p: 2, borderRadius: 3 }}>
//             <Typography variant="subtitle1" fontWeight="bold" mb={1}>
//               📦 Stock by Warehouse
//             </Typography>
//             <ResponsiveBar
//               data={totalStock}
//               keys={["total_weight"]}
//               indexBy="warehouse_code"
//               margin={{ top: 30, right: 20, bottom: 50, left: 60 }}
//               padding={0.3}
//               colors={{ scheme: "nivo" }}
//               axisBottom={{
//                 tickRotation: -30,
//               }}
//               labelSkipWidth={12}
//               labelSkipHeight={12}
//               theme={{
//                 textColor: theme.palette.text.primary,
//               }}
//             />
//           </Paper>
//         </Grid>

//         {/* Pie Chart - Inventory Category */}
//         <Grid item xs={12} md={6}>
//           <Paper elevation={3} sx={{ height: 300, p: 2, borderRadius: 3 }}>
//             <Typography variant="subtitle1" fontWeight="bold" mb={1}>
//               📊 Inventory by Category
//             </Typography>
//             <ResponsivePie
//               data={inventoryCategory}
//               margin={{ top: 30, right: 40, bottom: 40, left: 40 }}
//               innerRadius={0.5}
//               padAngle={1}
//               cornerRadius={4}
//               activeOuterRadiusOffset={8}
//               colors={{ scheme: "set2" }}
//               borderWidth={1}
//               borderColor={{ from: "color", modifiers: [["darker", 0.2]] }}
//               theme={{
//                 textColor: theme.palette.text.primary,
//               }}
//             />
//           </Paper>
//         </Grid>

//         {/* Line Chart - Inward vs Outward Trend */}
//         <Grid item xs={12}>
//           <Paper elevation={3} sx={{ height: 320, p: 2, borderRadius: 3 }}>
//             <Typography variant="subtitle1" fontWeight="bold" mb={1}>
//               📈 Inward vs Outward Shipments (Weekly Trend)
//             </Typography>
//             <ResponsiveLine
//               data={inwardAndOutwardShipment}
//               margin={{ top: 30, right: 80, bottom: 50, left: 60 }}
//               xScale={{ type: "point" }}
//               yScale={{ type: "linear", min: "auto", max: "auto", stacked: false }}
//               axisBottom={{ tickRotation: -30 }}
//               axisLeft={{ legend: "Shipments", legendOffset: -40, legendPosition: "middle" }}
//               colors={{ scheme: "category10" }}
//               pointSize={8}
//               pointColor={{ theme: "background" }}
//               pointBorderWidth={2}
//               pointBorderColor={{ from: "serieColor" }}
//               useMesh={true}
//               theme={{
//                 textColor: theme.palette.text.primary,
//               }}
//             />
//           </Paper>
//         </Grid>
//       </Grid>
//     </Box>
//   );
// };

// export default WarehouseDashboard;



// WarehouseDashboard.jsx
// import React, { useEffect, useMemo, useState } from "react";
// import {
//   Box,
//   Grid,
//   Paper,
//   Typography,
//   useTheme,
//   Avatar,
//   MenuItem,
//   FormControl,
//   Select,
//   InputLabel,
//   Stack,
//   IconButton,
//   Button,
//   TextField,
//   GlobalStyles,
// } from "@mui/material";
// import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
// import Inventory2Icon from "@mui/icons-material/Inventory2";
// import LocalShippingIcon from "@mui/icons-material/LocalShipping";
// import OutboxIcon from "@mui/icons-material/Outbox";
// import WarehouseIcon from "@mui/icons-material/Warehouse";
// import CategoryIcon from "@mui/icons-material/Category";
// import TrendingUpIcon from "@mui/icons-material/TrendingUp";
// import TrendingDownIcon from "@mui/icons-material/TrendingDown";
// import RefreshIcon from "@mui/icons-material/Refresh";

// import { ResponsiveBar } from "@nivo/bar";
// import { ResponsivePie } from "@nivo/pie";
// import { ResponsiveLine } from "@nivo/line";

// import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import dayjs from "dayjs";

// import useWarehouseDashboard from "../../../hooks/warehouse/useWarehouseDashboard";
// import { tokens } from "../../../theme/theme"; // adjust path if needed

// // ---------- Helper: safe percent calc ----------
// function percentChange(current = 0, previous = 0) {
//   if (previous === 0) return current === 0 ? 0 : 100;
//   return Math.round(((current - previous) / Math.abs(previous)) * 100);
// }

// // ---------- KPI Card component ----------
// const KPICard = ({ title, value, deltaPct, positive, icon, bg, textColor }) => {
//   return (
//     <Paper
//       elevation={3}
//       sx={{
//         display: "flex",
//         gap: 2,
//         alignItems: "center",
//         p: 2,
//         borderRadius: 3,
//         height: "120px",
//         transition: "transform .18s ease, box-shadow .18s ease",
//         cursor: "pointer",
//         "&:hover": {
//           transform: "translateY(-6px)",
//           boxShadow: 8,
//         },
//       }}
//     >
//       <Avatar
//         sx={{
//           bgcolor: bg,
//           width: 56,
//           height: 56,
//           boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
//         }}
//       >
//         {icon}
//       </Avatar>

//       <Box sx={{ flex: 1 }}>
//         <Typography variant="subtitle2" color="text.secondary">
//           {title}
//         </Typography>

//         <Stack direction="row" alignItems="center" spacing={2} sx={{ mt: 0.5 }}>
//           <Typography variant="h5" sx={{ fontWeight: 700 }}>
//             {typeof value === "number" ? value.toLocaleString() : value ?? "-"}
//           </Typography>

//           <Box
//             sx={{
//               display: "flex",
//               alignItems: "center",
//               gap: 0.5,
//               px: 1,
//               py: 0.3,
//               borderRadius: 2,
//               bgcolor: positive ? "rgba(76, 175, 80, 0.12)" : "rgba(244, 67, 54, 0.08)",
//               color: positive ? "success.main" : "error.main",
//               fontWeight: 700,
//               minWidth: 56,
//               justifyContent: "center",
//             }}
//           >
//             {positive ? <TrendingUpIcon sx={{ fontSize: 14 }} /> : <TrendingDownIcon sx={{ fontSize: 14 }} />}
//             <Typography variant="caption">{Math.abs(deltaPct)}%</Typography>
//           </Box>
//         </Stack>

//         <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5, display: "block" }}>
//           Compared to previous period
//         </Typography>
//       </Box>
//     </Paper>
//   );
// };

// // ---------- Custom portal-safe tooltip wrapper ----------
// const PortalSafeTooltipWrapper = ({ children, bg, color }) => {
//   // wrapper ensures parent background doesn't override inner tooltip and works with portals
//   return (
//     <div
//       style={{
//         background: "transparent",
//         padding: 0,
//         margin: 0,
//         boxShadow: "none",
//       }}
//     >
//       <div
//         style={{
//           padding: 8,
//           background: bg,
//           color,
//           borderRadius: 6,
//           boxShadow: "0 6px 18px rgba(0,0,0,0.12)",
//         }}
//       >
//         {children}
//       </div>
//     </div>
//   );
// };

// // ---------- Main Component ----------
// const WarehouseDashboard = () => {
//   const theme = useTheme();
//   const mode = theme?.palette?.mode || "dark";
//   const colors = tokens(mode);

//   // Your existing hook (assumed)
//   const {
//     totalStock = [],
//     inwardShipment = [],
//     outwardShipment = [],
//     spaceUtilization,
//     loading,
//     error,
//     kpiData = [],
//     inventoryCategory = [],
//     inwardAndOutwardShipment = [],
//     fetchDashBoardTopDetails,
//     warehouses = [], // optional list of warehouses for filter
//   } = useWarehouseDashboard();

//   // const { totalStock, inwardShipment, outwardShipment, spaceUtilization, loading, error,kpiData,inventoryCategory,inwardAndOutwardShipment, fetchDashBoardTopDetails,warehouses = [], } = useWarehouseDashboard();

//   // Local UI state: filters
//   const [fromDate, setFromDate] = useState(dayjs().subtract(7, "day"));
//   const [toDate, setToDate] = useState(dayjs());
//   const [selectedWarehouse, setSelectedWarehouse] = useState("all");
//   const [isDataLoad, setIsDataLoad] = useState(false);

//   useEffect(() => {
//     if (!isDataLoad) {
//       fetchDashBoardTopDetails?.();
//       setIsDataLoad(true);
//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, []);

//   // Derive KPIs safely with fallbacks
//   const kpis = useMemo(() => {
//     // if hook provides kpiData, map; else create from totals
//     if (Array.isArray(kpiData) && kpiData.length > 0) return kpiData;

//     // fallback example (safe defaults)
//     return [
//       { title: "Total Stock", value: totalStock.reduce((s, r) => s + (r.total_weight || 0), 0), prev: 0 },
//       { title: "Inward Shipments", value: inwardShipment.length, prev: Math.max(0, inwardShipment.length - 3) },
//       { title: "Outward Shipments", value: outwardShipment.length, prev: Math.max(0, outwardShipment.length - 2) },
//       { title: "Space Utilized", value: spaceUtilization ?? "N/A", prev: spaceUtilization ?? 0 },
//     ];
//   }, [kpiData, totalStock, inwardShipment, outwardShipment, spaceUtilization]);

//   // prepare chart data (you may filter by warehouse or date here)
//   // For demonstration we use the raw data returned by your hook
//   const barData = totalStock.map((r) => ({
//     warehouse_code: r.warehouse_code ?? r.warehouseName ?? "Unknown",
//     total_weight: r.total_weight ?? 0,
//   }));

//   const pieData = inventoryCategory.length
//     ? inventoryCategory
//     : [
//         // fallback
//         { id: "Paper", value: 60 },
//         { id: "Board", value: 25 },
//         { id: "Others", value: 15 },
//       ];

//   const lineData = inwardAndOutwardShipment.length
//     ? inwardAndOutwardShipment
//     : [
//         // fallback
//         {
//           id: "Inward",
//           color: "hsl(141, 70%, 50%)",
//           data: [
//             { x: "Mon", y: 30 },
//             { x: "Tue", y: 42 },
//             { x: "Wed", y: 55 },
//             { x: "Thu", y: 40 },
//             { x: "Fri", y: 70 },
//             { x: "Sat", y: 60 },
//             { x: "Sun", y: 80 },
//           ],
//         },
//         {
//           id: "Outward",
//           color: "hsl(348, 70%, 50%)",
//           data: [
//             { x: "Mon", y: 20 },
//             { x: "Tue", y: 35 },
//             { x: "Wed", y: 45 },
//             { x: "Thu", y: 30 },
//             { x: "Fri", y: 55 },
//             { x: "Sat", y: 50 },
//             { x: "Sun", y: 65 },
//           ],
//         },
//       ];

//   // Nivo theme (text + grid colors)
//   const nivoTheme = {
//     textColor: colors.grey[100],
//     axis: {
//       domain: { line: { stroke: colors.grey[500] } },
//       ticks: { line: { stroke: colors.grey[600] }, text: { fill: colors.grey[100] } },
//       legend: { text: { fill: colors.grey[100] } },
//     },
//     grid: {
//       line: { stroke: mode === "dark" ? colors.grey[800] : colors.grey[200] },
//     },
//     tooltip: {
//       container: {
//         background: colors.primary[400],
//         color: colors.grey[100],
//       },
//     },
//     legends: { text: { fill: colors.grey[100] } },
//   };

//   // Global tooltip CSS overrides (portal-safe because injected into head)
//   const globalStyles = {
//     /* make nivo tooltip wrapper transparent and remove default white table */
//     ".nivo-tooltip": {
//       background: "transparent !important",
//       color: "inherit !important",
//       boxShadow: "none !important",
//       padding: 0,
//     },
//     ".nivo-tooltip table, .nivo-tooltip td, .nivo-tooltip th": {
//       background: "transparent !important",
//       color: "inherit !important",
//     },
//     /* hide default tiny square if any */
//     ".chart-tooltip__colored-square, .nivo-tooltip .legendSwatch, .nivo-legend-item rect": {
//       background: "transparent !important",
//       display: "none !important",
//     },
//   };

//   // ---------- UI ----------
//   return (
//     <Box sx={{ p: 2 }}>
//       {/* Inject global overrides for nivo tooltip (portal safe) */}
//       <GlobalStyles styles={globalStyles} />

//       {/* CSS variables for extra safety (helpful if you set them at app root) */}
//       <div
//         style={{
//           "--nivo-tooltip-bg": colors.primary[400],
//           "--nivo-tooltip-color": colors.grey[100],
//         }}
//       />

//       <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mb: 2 }}>
//         <Typography variant="h5" fontWeight="bold">
//           🏭 Warehouse Dashboard
//         </Typography>

//         {/* Filters: Date range + warehouse + refresh */}
//         <Stack direction="row" spacing={1} alignItems="center">
//           <LocalizationProvider dateAdapter={AdapterDayjs}>
//             <DatePicker
//               label="From"           
//               value={fromDate}
//               onChange={(newVal) => setFromDate(newVal)}
//               renderInput={(params) => <TextField size="small" {...params} />}
//             />
//             <DatePicker
//               label="To"
//               value={toDate}
//               onChange={(newVal) => setToDate(newVal)}
//               renderInput={(params) => <TextField size="small" {...params} />}
//             />
//           </LocalizationProvider>

//           <FormControl size="small" sx={{ minWidth: 160 }}>
//             <InputLabel>Warehouse</InputLabel>
//             <Select
//               value={selectedWarehouse}
//               label="Warehouse"
//               onChange={(e) => setSelectedWarehouse(e.target.value)}
//             >
//               <MenuItem value="all">All Warehouses</MenuItem>
//               {(warehouses || []).map((w) => (
//                 <MenuItem key={w.code ?? w.id} value={w.code ?? w.id}>
//                   {w.name ?? w.code}
//                 </MenuItem>
//               ))}
//             </Select>
//           </FormControl>

//           <Button
//             variant="contained"
//             color="secondary"
//             startIcon={<RefreshIcon />}
//             onClick={() => fetchDashBoardTopDetails?.()}
//           >
//             Refresh
//           </Button>
//         </Stack>
//       </Stack>

//       {/* KPI Cards */}
//       <Grid container spacing={2} sx={{ mb: 2 }}>
//         {kpis.map((k, idx) => {
//           const prev = k.prev ?? 0;
//           const cur = typeof k.value === "number" ? k.value : Number(k.value) || 0;
//           const deltaPct = percentChange(cur, prev);
//           const positive = deltaPct >= 0;
//           // choose icon & color
//           const map = {
//             "Total Stock": { icon: <Inventory2Icon />, bg: colors.blueAccent[500] },
//             "Inward Shipments": { icon: <LocalShippingIcon />, bg: colors.greenAccent[500] },
//             "Outward Shipments": { icon: <OutboxIcon />, bg: colors.orangeAccent[500] },
//             "Space Utilized": { icon: <WarehouseIcon />, bg: colors.purpleAccent[500] },
//             Categories: { icon: <CategoryIcon />, bg: colors.yellowAccent[500] },
//           };
//           const pick = map[k.title] || { icon: <CategoryIcon />, bg: colors.primary[400] };

//           return (
//             <Grid item xs={12} sm={6} md={3} key={idx}>
//               <KPICard
//                 title={k.title}
//                 value={k.value}
//                 deltaPct={Math.abs(deltaPct)}
//                 positive={positive}
//                 icon={pick.icon}
//                 bg={pick.bg}
//                 textColor={colors.grey[100]}
//               />
//             </Grid>
//           );
//         })}
//       </Grid>

//       {/* Charts */}
//       <Grid container spacing={2}>
//         {/* Bar */}
//         <Grid item xs={12} md={6}>
//           <Paper elevation={3} sx={{ height: 360, p: 2, borderRadius: 3 }}>
//             <Typography variant="subtitle1" fontWeight="bold" mb={1}>
//               📦 Stock by Warehouse
//             </Typography>

//             <Box sx={{ height: 300 }}>
//               <ResponsiveBar
//                 data={barData}
//                 keys={["total_weight"]}
//                 indexBy="warehouse_code"
//                 margin={{ top: 30, right: 24, bottom: 80, left: 80 }}
//                 padding={0.3}
//                 colors={{ scheme: mode === "dark" ? "dark2" : "set2" }}
//                 axisBottom={{
//                   tickRotation: -30,
//                 }}
//                 labelSkipWidth={12}
//                 labelSkipHeight={12}
//                 theme={nivoTheme}
//                 tooltip={({ indexValue, value, color }) => (
//                   <PortalSafeTooltipWrapper bg={colors.primary[400]} color={colors.grey[100]}>
//                     <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
//                       <div style={{ width: 10, height: 10, background: color, borderRadius: 3 }} />
//                       <div>
//                         <strong>{indexValue}</strong>
//                         <div>{value ?? 0}</div>
//                       </div>
//                     </div>
//                   </PortalSafeTooltipWrapper>
//                 )}
//               />
//             </Box>
//           </Paper>
//         </Grid>

//         {/* Pie */}
//         <Grid item xs={12} md={6}>
//           <Paper elevation={3} sx={{ height: 360, p: 2, borderRadius: 3 }}>
//             <Typography variant="subtitle1" fontWeight="bold" mb={1}>
//               📊 Inventory by Category
//             </Typography>

//             <Box sx={{ height: 300 }}>
//               <ResponsivePie
//                 data={pieData}
//                 margin={{ top: 30, right: 40, bottom: 60, left: 40 }}
//                 innerRadius={0.48}
//                 padAngle={1}
//                 cornerRadius={6}
//                 activeOuterRadiusOffset={8}
//                 colors={{ scheme: mode === "dark" ? "dark2" : "paired" }}
//                 borderWidth={1}
//                 borderColor={{ from: "color", modifiers: [["darker", 0.2]] }}
//                 theme={nivoTheme}
//                 arcLabel={(d) => `${d.value}`}
//                 tooltip={({ datum }) => (
//                   <PortalSafeTooltipWrapper bg={colors.primary[400]} color={colors.grey[100]}>
//                     <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
//                       <div style={{ width: 10, height: 10, background: datum.color, borderRadius: 3 }} />
//                       <div>
//                         <strong>{datum.id}</strong>
//                         <div>{datum.value}</div>
//                       </div>
//                     </div>
//                   </PortalSafeTooltipWrapper>
//                 )}
//                 legends={[
//                   {
//                     anchor: "bottom",
//                     direction: "row",
//                     translateY: 42,
//                     itemWidth: 90,
//                     itemHeight: 20,
//                     symbolSize: 10,
//                   },
//                 ]}
//               />
//             </Box>
//           </Paper>
//         </Grid>

//         {/* Line */}
//         <Grid item xs={12}>
//           <Paper elevation={3} sx={{ height: 420, p: 2, borderRadius: 3 }}>
//             <Typography variant="subtitle1" fontWeight="bold" mb={1}>
//               📈 Inward vs Outward Shipments (Weekly Trend)
//             </Typography>

//             <Box sx={{ height: 360 }}>
//               <ResponsiveLine
//                 data={lineData}
//                 margin={{ top: 30, right: 100, bottom: 80, left: 80 }}
//                 xScale={{ type: "point" }}
//                 yScale={{ type: "linear", min: "auto", max: "auto", stacked: false }}
//                 axisBottom={{ tickRotation: -30 }}
//                 axisLeft={{ legend: "Shipments", legendOffset: -60, legendPosition: "middle" }}
//                 colors={{ scheme: "category10" }}
//                 pointSize={8}
//                 pointBorderWidth={2}
//                 pointBorderColor={{ from: "serieColor" }}
//                 useMesh={true}
//                 theme={nivoTheme}
//                 tooltip={({ point }) => {
//                   const { data } = point || {};
//                   return (
//                     <PortalSafeTooltipWrapper bg={colors.primary[400]} color={colors.grey[100]}>
//                       <div>
//                         <strong>{data.serieId}</strong>
//                         <div>{data.x}: {data.y}</div>
//                       </div>
//                     </PortalSafeTooltipWrapper>
//                   );
//                 }}
//               />
//             </Box>
//           </Paper>
//         </Grid>
//       </Grid>
//     </Box>
//   );
// };

// export default WarehouseDashboard;





// src/features/warehouse/WarehouseDashboard.jsx
import React, { useEffect, useMemo, useState } from "react";
import {
  Box,
  Grid,
  Paper,
  Typography,
  useTheme,
  Avatar,
  MenuItem,
  FormControl,
  Select,
  InputLabel,
  Stack,
  Button,
  TextField,
  GlobalStyles,
} from "@mui/material";

import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import Inventory2Icon from "@mui/icons-material/Inventory2";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import OutboxIcon from "@mui/icons-material/Outbox";
import WarehouseIcon from "@mui/icons-material/Warehouse";
import CategoryIcon from "@mui/icons-material/Category";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import TrendingDownIcon from "@mui/icons-material/TrendingDown";
import RefreshIcon from "@mui/icons-material/Refresh";
import SpaceBarIcon from '@mui/icons-material/SpaceBar';

import { ResponsiveBar } from "@nivo/bar";
import { ResponsivePie } from "@nivo/pie";
import { ResponsiveLine } from "@nivo/line";

import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";

import useWarehouseDashboard from "../../../hooks/warehouse/useWarehouseDashboard";
import { tokens } from "../../../theme/theme"; // adjust if your theme path differs

// ---------- Helpers ----------
function percentChange(current = 0, previous = 0) {
  if (previous === 0) return current === 0 ? 0 : 100;
  return Math.round(((current - previous) / Math.abs(previous)) * 100);
}

// ---------- KPI Card ----------
const KPICard = ({ title, value, deltaPct, positive, icon, bg }) => {
  return (
    <Paper
      elevation={1}
      sx={{
        display: "flex",
        gap: 2,
        alignItems: "center",
        p: 2,
        borderRadius: 3,
        height: "120px",
        transition: "transform .18s ease, box-shadow .18s ease",
        cursor: "pointer",
        "&:hover": {
          transform: "translateY(-6px)",
          boxShadow: 8,
        },
      }}
    >
      <Avatar
        sx={{
          bgcolor: bg,
          width: 56,
          height: 56,
          boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
        }}
      >
        {icon}
      </Avatar>

      <Box sx={{ flex: 1 }}>
        <Typography variant="subtitle2" color="text.secondary">
          {title}
        </Typography>

        <Stack direction="row" alignItems="center" spacing={2} sx={{ mt: 0.5 }}>
          <Typography variant="h5" sx={{ fontWeight: 700 }}>
            {typeof value === "number" ? value.toLocaleString() : value ?? "-"}
          </Typography>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 0.5,
              px: 1,
              py: 0.3,
              borderRadius: 2,
              bgcolor: positive ? "rgba(76,175,80,0.12)" : "rgba(244,67,54,0.08)",
              color: positive ? "success.main" : "error.main",
              fontWeight: 700,
              minWidth: 56,
              justifyContent: "center",
            }}
          >
            {positive ? <TrendingUpIcon sx={{ fontSize: 14 }} /> : <TrendingDownIcon sx={{ fontSize: 14 }} />}
            <Typography variant="caption">{Math.abs(deltaPct)}%</Typography>
          </Box>
        </Stack>

        <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5, display: "block" }}>
          Compared to previous period
        </Typography>
      </Box>
    </Paper>
  );
};

// ---------- Portal safe tooltip wrapper (for Nivo portal tooltips) ----------
const PortalSafeTooltipWrapper = ({ children, bg, color }) => {
  return (
    <div style={{ background: "transparent", padding: 0, margin: 0, boxShadow: "none" }}>
      <div style={{ padding: 8, background: bg, color, borderRadius: 6, boxShadow: "0 6px 18px rgba(0,0,0,0.12)" }}>
        {children}
      </div>
    </div>
  );
};

// ---------- Main component ----------
const WarehouseDashboard = () => {
  const theme = useTheme();
  const mode = theme?.palette?.mode || "dark";
  const colors = tokens(mode);

  // your data hook - should provide data + fetch fn
  const {
    totalStock = [],
    inwardShipment = [],
    outwardShipment = [],
    spaceUtilization,
    loading,
    error,
    kpiData = [],
    inventoryCategory = [],
    inwardAndOutwardShipment = [],
    fetchDashBoardTopDetails,
    warehouses = [],
  } = useWarehouseDashboard();

  // local UI state
  const [fromDate, setFromDate] = useState(dayjs().subtract(7, "day"));
  const [toDate, setToDate] = useState(dayjs());
  const [selectedWarehouse, setSelectedWarehouse] = useState("all");
  const [isDataLoad, setIsDataLoad] = useState(false);

  useEffect(() => {
    if (!isDataLoad) {
      fetchDashBoardTopDetails?.();
      setIsDataLoad(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // KPI fallback creation
  const kpis = useMemo(() => {
    if (Array.isArray(kpiData) && kpiData.length > 0) return kpiData;
    return [
      { title: "Total Warehouses", value: Math.round(totalStock.reduce((s, r) => s + (r.total_weight || 0), 0)), prev: 0 },
      { title: "Total Stock", value: Math.round(totalStock.reduce((s, r) => s + (r.total_weight || 0), 0)), prev: 0 },
      { title: "Inward Shipments", value: inwardShipment.length, prev: Math.max(0, inwardShipment.length - 3) },
      { title: "Outward Shipments", value: outwardShipment.length, prev: Math.max(0, outwardShipment.length - 2) },
      { title: "Space Utilized", value: spaceUtilization ?? "N/A", prev: spaceUtilization ?? 0 },
    ];
  }, [kpiData, totalStock, inwardShipment, outwardShipment, spaceUtilization]);

  // chart data preparation
  const barData = totalStock.map((r) => ({
    warehouse_code: r.warehouse_code ?? r.warehouseName ?? "Unknown",
    total_weight: r.total_weight ?? 0,
  }));

  const pieData = Array.isArray(inventoryCategory) && inventoryCategory.length
    ? inventoryCategory
    : [
      { id: "Reel", value: 60 },
      { id: "Bundle", value: 25 },
      { id: "ReamPallet", value: 15 },
    ];

  const lineData = Array.isArray(inwardAndOutwardShipment) && inwardAndOutwardShipment.length
    ? inwardAndOutwardShipment
    : [
      {
        id: "Inward",
        data: [
          { x: "Mon", y: 30 },
          { x: "Tue", y: 42 },
          { x: "Wed", y: 55 },
          { x: "Thu", y: 40 },
          { x: "Fri", y: 70 },
          { x: "Sat", y: 60 },
          { x: "Sun", y: 80 },
        ],
      },
      {
        id: "Outward",
        data: [
          { x: "Mon", y: 20 },
          { x: "Tue", y: 35 },
          { x: "Wed", y: 45 },
          { x: "Thu", y: 30 },
          { x: "Fri", y: 55 },
          { x: "Sat", y: 50 },
          { x: "Sun", y: 65 },
        ],
      },
    ];

  // nivo theme using your tokens
  const nivoTheme = {
    textColor: colors.grey[100],
    axis: {
      domain: { line: { stroke: colors.grey[500] } },
      ticks: { line: { stroke: colors.grey[600] }, text: { fill: colors.grey[100] } },
      legend: { text: { fill: colors.grey[100] } },
    },
    grid: {
      line: { stroke: mode === "dark" ? colors.grey[800] : colors.grey[200] },
    },
    tooltip: {
      container: {
        background: colors.primary[400],
        color: colors.grey[100],
      },
    },
    legends: { text: { fill: colors.grey[100] } },
  };

  // global styles for portal tooltips (ensures Nivo tooltips are readable)
  const globalStyles = {
    ".nivo-tooltip": {
      background: "transparent !important",
      color: "inherit !important",
      boxShadow: "none !important",
      padding: 0,
    },
    ".nivo-tooltip table, .nivo-tooltip td, .nivo-tooltip th": {
      background: "transparent !important",
      color: "inherit !important",
    },
    ".chart-tooltip__colored-square, .nivo-tooltip .legendSwatch, .nivo-legend-item rect": {
      background: "transparent !important",
      display: "none !important",
    },
  };

  // fixed icon mapping - stable (icons won't flip after load)
  const iconMap = {
    "Total Warehouses": <WarehouseIcon />,
    "Total Stock (MT)": <Inventory2Icon />,
    "Inward Shipments (Today)": <LocalShippingIcon />,
    "Outward Shipments (Today)": <OutboxIcon />,
    "Space Utilization": <SpaceBarIcon />,
  };

  // color map for KPIs (use tokens)
  const kpiColorMap = {
    "Total Warehouses": colors.yellowAccent?.[500] ?? colors.primary[400],
    "Total Stock (MT)": colors.blueAccent?.[500] ?? colors.primary[400],
    "Inward Shipments (Today)": colors.greenAccent?.[500] ?? colors.primary[400],
    "Outward Shipments (Today)": colors.orangeAccent?.[500] ?? colors.primary[400],
    "Space Utilization": colors.purpleAccent?.[500] ?? colors.primary[400],
  };

  return (
    <Box sx={{ p: 2 }}>
      <GlobalStyles styles={globalStyles} />

      {/* header + filters */}
      {/* <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mb: 2 }}>
        <Typography variant="h5" fontWeight="bold">
          🏭 Warehouse Dashboard
        </Typography>

        <Stack direction="row" spacing={1} alignItems="center">
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="From"
              value={fromDate}
              onChange={(newVal) => setFromDate(newVal)}
              renderInput={(params) => <TextField size="small" {...params} />}
            />
            <DatePicker
              label="To"
              value={toDate}
              onChange={(newVal) => setToDate(newVal)}
              renderInput={(params) => <TextField size="small" {...params} />}
            />
          </LocalizationProvider>

          <FormControl size="small" sx={{ minWidth: 180 }}>
            <InputLabel>Warehouse</InputLabel>
            <Select value={selectedWarehouse} label="Warehouse" onChange={(e) => setSelectedWarehouse(e.target.value)}>
              <MenuItem value="all">All Warehouses</MenuItem>
              {(warehouses || []).map((w ,idx) => (
                <MenuItem key={w.code ?? w.id} value={w.code ?? w.id}>
                  {w.name ?? w.warehouse_name ?? w.code ?? `WH-${w.id ?? idx}`}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <Button
            variant="contained"
            color="secondary"
            startIcon={<RefreshIcon />}
            onClick={() => fetchDashBoardTopDetails?.()}
          >
            Refresh
          </Button>
        </Stack>
      </Stack> */}
{/* 🏭 */}
      <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mb: 2 }}>
        <Typography variant="h5" fontWeight="bold">
           Warehouse Dashboard
        </Typography>

        <Stack direction="row" spacing={1} alignItems="center" marginBottom={1}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="From"
              value={fromDate}
              onChange={(newVal) => setFromDate(newVal)}
              slotProps={{
                textField: {
                  size: "small",
                  sx: { width: 150 } // adjust size here
                }
              }}
            />

            <DatePicker
              label="To"
              value={toDate}
              onChange={(newVal) => setToDate(newVal)}
              slotProps={{
                textField: {
                  size: "small",
                  sx: { width: 150 } // adjust size here
                }
              }}
            />
          </LocalizationProvider>

          <FormControl size="small" sx={{ minWidth: 180 }}>
            <InputLabel>Warehouse</InputLabel>
            <Select
              value={selectedWarehouse}
              label="Warehouse"
              onChange={(e) => setSelectedWarehouse(e.target.value)}
            >
              <MenuItem value="all">All Warehouses</MenuItem>
              {(warehouses || []).map((w, idx) => (
                <MenuItem key={w.code ?? w.id} value={w.code ?? w.id}>
                  {w.name ?? w.warehouse_name ?? w.code ?? `WH-${w.id ?? idx}`}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <Button
            variant="contained"
            color="secondary"
            startIcon={<RefreshIcon />}
            onClick={() => fetchDashBoardTopDetails?.()}
          >
            Refresh
          </Button>
        </Stack>
      </Stack>


      {/* KPI cards */}
      <Grid container spacing={2} sx={{ mb: 2 }}>
        {kpis.map((k, idx) => {
          const prev = k.prev ?? 0;
          const cur = typeof k.value === "number" ? k.value : Number(k.value) || 0;
          const deltaPct = percentChange(cur, prev);
          const positive = deltaPct >= 0;

          const icon = iconMap[k.title] ?? <CategoryIcon />;
          const bg = kpiColorMap[k.title] ?? colors.primary[400];

          return (
            <Grid item xs={12} sm={6} md={3} key={k.title + idx}>
              <KPICard title={k.title} value={k.value} deltaPct={Math.abs(deltaPct)} positive={positive} icon={icon} bg={bg} />
            </Grid>
          );
        })}
      </Grid>

      {/* Charts */}
      <Grid container spacing={2}>
        {/* Bar */}
        <Grid item xs={12} md={6}>
          <Paper elevation={3} sx={{ p: 2, height: 380, borderRadius: 3 }}>
            <Typography variant="h6" sx={{ mb: 1 }}>
              📦 Stock by Warehouse
            </Typography>

            <Box sx={{ height: 300 }}>
              <ResponsiveBar
                data={barData}
                keys={["total_weight"]}
                indexBy="warehouse_code"
                theme={nivoTheme}
                margin={{ top: 40, right: 30, bottom: 60, left: 70 }}
                padding={0.3}
                colors={{ scheme: mode === "dark" ? "dark2" : "set2" }}
                borderRadius={4}
                tooltip={({ value, indexValue, color }) => (
                  <PortalSafeTooltipWrapper bg={colors.primary[400]} color={colors.grey[100]}>
                    <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                      <div style={{ width: 10, height: 10, background: color, borderRadius: 3 }} />
                      <div>
                        <strong>{indexValue}</strong>
                        <div>{(value ?? 0).toLocaleString()}</div>
                      </div>
                    </div>
                  </PortalSafeTooltipWrapper>
                )}
                axisBottom={{ tickRotation: -30 }}
              />
            </Box>
          </Paper>
        </Grid>

        {/* Pie */}
        <Grid item xs={12} md={6}>
          <Paper elevation={3} sx={{ p: 2, height: 380, borderRadius: 3 }}>
            <Typography variant="h6" sx={{ mb: 1 }}>
              📊 Inventory by Category
            </Typography>

            <Box sx={{ height: 300 }}>
              <ResponsivePie
                data={pieData}
                margin={{ top: 40, right: 80, bottom: 70, left: 80 }}
                innerRadius={0.5}
                padAngle={1}
                cornerRadius={4}
                activeOuterRadiusOffset={6}
                theme={nivoTheme}
                colors={{ scheme: mode === "dark" ? "dark2" : "paired" }}
                borderWidth={1}
                borderColor={{ from: "color", modifiers: [["darker", 0.2]] }}
                tooltip={({ datum }) => (
                  <PortalSafeTooltipWrapper bg={colors.primary[400]} color={colors.grey[100]}>
                    <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                      <div style={{ width: 10, height: 10, background: datum.color, borderRadius: 3 }} />
                      <div>
                        <strong>{datum.id}</strong>
                        <div>{datum.value}</div>
                      </div>
                    </div>
                  </PortalSafeTooltipWrapper>
                )}
                legends={[
                  {
                    anchor: "bottom",
                    direction: "row",
                    translateY: 42,
                    itemWidth: 90,
                    itemHeight: 20,
                    symbolSize: 10,
                  },
                ]}
              />
            </Box>
          </Paper>
        </Grid>

        {/* Line */}
        <Grid item xs={12}>
          <Paper elevation={3} sx={{ p: 2, height: 420, borderRadius: 3 }}>
            <Typography variant="h6" sx={{ mb: 1 }}>
              📈 Inward vs Outward Shipments (Weekly Trend)
            </Typography>

            <Box sx={{ height: 360 }}>
              <ResponsiveLine
                data={lineData}
                margin={{ top: 30, right: 100, bottom: 80, left: 80 }}
                xScale={{ type: "point" }}
                yScale={{ type: "linear", min: "auto", max: "auto", stacked: false }}
                axisBottom={{ tickRotation: -30 }}
                axisLeft={{ legend: "Shipments", legendOffset: -60, legendPosition: "middle" }}
                colors={{ scheme: "category10" }}
                pointSize={8}
                pointBorderWidth={2}
                pointBorderColor={{ from: "serieColor" }}
                useMesh={true}
                theme={nivoTheme}
                tooltip={({ point }) => {
                  const { data } = point || {};
                  return (
                    <PortalSafeTooltipWrapper bg={colors.primary[400]} color={colors.grey[100]}>
                      <div>
                        <strong>{data.serieId ?? point?.serieId}</strong>
                        <div>
                          {data.x}: {data.y}
                        </div>
                      </div>
                    </PortalSafeTooltipWrapper>
                  );
                }}
              />
            </Box>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};

export default WarehouseDashboard;


